import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  const footerCategories = categories.slice(0, 5);
  const footerGuides = [
    { name: 'Guia CSSBuy 2026', url: '/guia-cssbuy-spreadsheet-2026' },
    { name: 'Top Sneakers', url: '/melhores-sneakers-cssbuy-spreadsheet' },
    { name: 'Comparar Agentes', url: '/agentes-china-comparacao-cssbuy' },
  ];

  return (
    <footer className="bg-secondary-900 pt-16 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block cursor-pointer">
              <h3 className="text-xl font-heading font-bold text-white">
                CSSBuy Spreadsheet<span className="text-accent-500">.</span>
              </h3>
            </Link>
            <p className="mt-4 text-sm text-white/60 max-w-sm leading-relaxed">
              {t('footer.promo')}
              <br />
              {t('footer.promo2')}
            </p>
          </div>

          {/* Categorias */}
          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase text-white/50 font-semibold mb-4">
              {t('footer.categorias')}
            </h4>
            <ul className="space-y-2.5">
              {footerCategories.map((cat, i) => (
                <li key={i}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Guias */}
          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase text-white/50 font-semibold mb-4">
              {t('footer.guias')}
            </h4>
            <ul className="space-y-2.5">
              {footerGuides.map((guide, i) => (
                <li key={i}>
                  <Link
                    to={guide.url}
                    className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                  >
                    {guide.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal + Shopping Guide */}
          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase text-white/50 font-semibold mb-4">
              Guia de Compras
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                >
                  Planilha Completa
                  <i className="ri-external-link-line ml-1 w-3 h-3 inline-flex items-center justify-center"></i>
                </a>
              </li>
              <li>
                <Link
                  to="/cssbuy-e-seguro-analise"
                  className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                >
                  CSSBuy é Seguro?
                </Link>
              </li>
              <li>
                <Link
                  to="/guia-envio-cssbuy-europa"
                  className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                >
                  Guia de Envio Europa
                </Link>
              </li>
            </ul>
            <h4 className="text-xs tracking-[0.15em] uppercase text-white/50 font-semibold mt-6 mb-4">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                  {t('footer.privacy')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/40">
            {t('footer.copyright')}
          </p>
          <p className="text-xs text-white/30">
            {t('footer.promo')} {t('footer.promo2')}
          </p>
        </div>
      </div>
    </footer>
  );
}